import { TOKEN_TYPE } from "../TokenType.js";
import Token from "../Token.js";

export default class BooleanToken extends Token {
    constructor( value ) {
        super( TOKEN_TYPE.BOOLEAN, value );
    }
}
